import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { provideComponentStore } from '@ngrx/component-store';
import { ofType } from '@ngrx/effects';
import { ActionsSubject, Store } from '@ngrx/store';
import { tap } from 'rxjs';
import { UserPermission } from 'src/app/core/enums/user/user-permission.enum';
import { userProfile } from 'src/app/shared/user/user.selectors';
import { ConfirmDialogComponent } from '../../dialogs/confirm-dialog/confirm-dialog.component';
import { CloseSidenavAction } from '../sidenav.actions';
import { SidenavContentLeadInfo } from './sidenav-content-lead-info.store';
import { LeadActions } from 'src/app/core/events/lead.actions';

@Component({
    selector: 'sidenav-content-lead-info-container',
    templateUrl: './sidenav-content-lead-info-container.component.html',
    styleUrls: ['./sidenav-content-lead-info-container.component.scss'],
    providers: provideComponentStore(SidenavContentLeadInfo),
    standalone: false
})
export class SidenavContentLeadInfoContainerComponent implements OnInit, OnChanges {

  @Input() set leadId(id: number | null | undefined) {
    this._leadId = id ?? undefined
    if (id) this.store.loadLeadInfo(id)
    else this.store.offloadLeadInfo
  }

  @Input() shouldShowDetails: boolean = true
  @Input() shouldShowHistoryTransitions: boolean = true
  @Input() shouldShowHistoryAudits: boolean = true

  @Input() showDetailsFooterResume: boolean = true

  lead$ = this.store.lead$
  user$ = this.appStore.pipe(userProfile)

  showTabs: boolean = false
  askConfirmationOnClose: boolean = false
  canViewFirstAcquisitionData: boolean = false
  sidenavOpen: boolean = false
  userPermission = UserPermission

  _leadId: number | undefined

  constructor(private readonly appStore: Store,
    private readonly store: SidenavContentLeadInfo,
    actions$: ActionsSubject,
    private readonly dialog: MatDialog) {
    this.user$.subscribe(user => this.canViewFirstAcquisitionData = user.permissions.includes(UserPermission.SearchLeadAudit))

    actions$.pipe(
      ofType(LeadActions.leadQualified),
      tap((action) => {
        if (action.leadId == this._leadId)
          this.store.loadLeadInfo(action.leadId)
      })
    ).subscribe()

    actions$.pipe(
      ofType(LeadActions.leadInfoModified),
      tap((action) => {
        if (action.lead.id == this._leadId)
          this.store.setLeadInfo(action.lead)
      })
    ).subscribe()

  }

  ngOnInit(): void {
    this.showTabs = this.computeShowTabs()
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.showTabs = this.computeShowTabs()
  }

  onCloseClick() {
    this.close()
  }

  onRefreshLeadInfo() {
    this.store.reloadLeadInfo()
  }

  onLeadModified() {
    this.askConfirmationOnClose = false
    this.close()
  }

  onShowLeadReceivedInformation() {
    // this.sidenavOpen = true
    this.store.showReceivedLeadInfoDialog()
  }

  close() {
    if (this.askConfirmationOnClose) {
      const confirmDialog = this.dialog.open(ConfirmDialogComponent, ConfirmDialogComponent.createConfigurations(
        {
          title: 'Conferma',
          message: 'Modifiche non salvate. Se procedi saranno perdute',
          confirmButtonText: 'Procedi',
          cancelButtonText: 'Annulla'
        }
      ))

      confirmDialog.afterClosed().subscribe(result => {
        if (result) this.appStore.dispatch(CloseSidenavAction())
      })
    }
    else this.appStore.dispatch(CloseSidenavAction())
  }

  private computeShowTabs() {
    return (this.shouldShowDetails && (this.shouldShowHistoryAudits || this.shouldShowHistoryTransitions)) ||
      this.shouldShowHistoryAudits && (this.shouldShowDetails || this.shouldShowHistoryTransitions) ||
      this.shouldShowHistoryTransitions && (this.shouldShowDetails || this.shouldShowHistoryAudits)
  }

}
